import React, { useState } from 'react';
import {
    ConfigProvider,
    theme,
    Table,
    Avatar,
    Input,
    Button,
    Modal,
    Tabs,
    Dropdown
} from 'antd';
import {
    Minus,
    Plus,
    Paperclip,
    Send,
    Smile,
    User,
    History,
    CheckSquare,
    Activity,
    MessageSquareDashed, // Icon cho trạng thái rỗng
    MoreVertical,
    ChevronRight,
    CornerUpLeft,
    FileText,
    Package,
    UserPlus,
    ChevronDown,
    Check,
} from 'lucide-react';
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import Layout from '../../Layout'; // Giữ nguyên layout của bạn
import { Link } from "react-router-dom";

const { TextArea } = Input;

export default function OrderDetail() {
    const [isDarkMode, setIsDarkMode] = useState(false);

    // Thêm state này để quản lý trạng thái Đã duyệt hay chưa
    const [isApproved, setIsApproved] = useState(false);
    // ================= STATES =================
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);

    // Collapse States
    const [expandedBlocks, setExpandedBlocks] = useState({
        general: true,
        orderContent: true,
    });

    const toggleBlock = (key) => {
        setExpandedBlocks(prev => ({ ...prev, [key]: !prev[key] }));
    };

    // State Thảo luận (Mặc định mảng rỗng để hiện Empty State)
    const [comments, setComments] = useState([]);
    const [inputValue, setInputValue] = useState('');

    const handleSendComment = () => {
        if (!inputValue.trim()) return;
        const newComment = { id: Date.now(), author: 'Mr. Huấn', text: inputValue, time: 'Vừa xong' };
        setComments([...comments, newComment]);
        setInputValue('');
    };

    // ================= MOCK DATA BẢNG (Chỉ đọc) =================
    const productColumns = [
        { title: 'STT', dataIndex: 'stt', key: 'stt', width: 60, align: 'center' },
        { title: 'Sản phẩm', dataIndex: 'name', key: 'name' },
        { title: 'Đơn vị', dataIndex: 'unit', key: 'unit', width: 100 },
        { title: 'Giá', dataIndex: 'price', key: 'price', align: 'right', width: 150 },
        { title: 'Số lượng', dataIndex: 'qty', key: 'qty', align: 'right', width: 100 },
        { title: 'Thành tiền', dataIndex: 'total', key: 'total', align: 'right', width: 150, className: 'font-medium' },
    ];

    const productData = [
        { key: '1', stt: '1', name: 'VPP001 - Bảng văn phòng', unit: 'Cái', price: '200.000 ₫', qty: '1', total: '200.000 ₫' },
    ];

    // ================= THEME =================
    const antdThemeConfig = {
        token: {
            colorPrimary: '#3e91ab',
            colorBgContainer: isDarkMode ? '#1f2937' : '#ffffff',
            colorText: isDarkMode ? '#f3f4f6' : '#374151',
            colorBorder: isDarkMode ? '#4b5563' : '#d1d5db',
            borderRadius: 6,
        },
        components: { Table: { headerBg: isDarkMode ? '#374151' : '#f9fafb' } },
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    };

    const CardHeader = ({ title, blockKey }) => (
        <div className="flex justify-between items-center mb-4 pb-2 border-b dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 px-4 py-2 -mx-4 -mt-4 rounded-t-lg">
            <h3 className="font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
            <div onClick={() => toggleBlock(blockKey)} className="cursor-pointer text-gray-400 hover:text-[#3e91ab] p-1">
                {expandedBlocks[blockKey] ? <Minus size={16} /> : <Plus size={16} />}
            </div>
        </div>
    );

    return (
        <Layout>
            <ConfigProvider theme={antdThemeConfig}>
                <div className={`min-h-screen pb-10 transition-colors duration-300`}>

                    {/* Header cố định */}
                    <div className="bg-white dark:bg-gray-800 p-4 sticky top-[64px] z-10 shadow-sm flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm border dark:border-gray-700">
                        <div className="flex items-center gap-2 text-sm">
                            <Link to="/purchase-order" className="flex items-center gap-2">
                                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#3e91ab] hover:bg-[#357f96] text-white">
                                    <LeftOutlined className="text-[10px]" />
                                </div>
                            </Link>
                            <span className="font-medium text-[#3e91ab] border-b-2 border-[#3e91ab] pb-0.5 whitespace-nowrap">Chi tiết đơn hàng</span>
                        </div>

                        {/* Toolbar Nút bấm */}
                        <div className="flex md:justify-end justify-start items-center gap-4 text-xs md:text-sm text-gray-600 dark:text-gray-300 overflow-x-auto no-scrollbar w-full whitespace-nowrap">

                            {/* Các nút bấm bên trong giữ nguyên */}

                            {/* NÚT DUYỆT / HOÀN DUYỆT ĐỘNG */}
                            {isApproved ? (
                                <button
                                    className="flex items-center gap-1.5 hover:text-[#3e91ab] transition-colors shrink-0"
                                    onClick={() => setIsApproved(false)}
                                >
                                    <CornerUpLeft size={14} /> Hoàn duyệt
                                </button>
                            ) : (
                                <button
                                    className="flex items-center gap-1.5 hover:text-[#3e91ab] transition-colors shrink-0"
                                    onClick={() => setIsApproveModalOpen(true)}
                                >
                                    <Check size={14} /> Duyệt
                                </button>
                            )}

                            <button className="flex items-center gap-1.5 hover:text-[#3e91ab] transition-colors shrink-0">
                                <FileText size={14} /> Phiếu chi
                            </button>

                            <Dropdown menu={{ items: [{ key: '1', label: 'Phiếu nhập kho' }, { key: '2', label: 'Phiếu nội bộ không qua kho' }] }} trigger={['click']}>
                                <button className="flex items-center gap-1.5 hover:text-[#3e91ab] transition-colors shrink-0">
                                    <Package size={14} /> Xuất nhập kho
                                </button>
                            </Dropdown>

                            <button className="flex items-center gap-1.5 hover:text-[#3e91ab] transition-colors text-000000e0 shrink-0">
                                <UserPlus size={14} /> Người theo dõi
                            </button>

                            <Dropdown menu={{ items: [{ key: '1', label: 'Tùy chọn 1' }, { key: '2', label: 'Tùy chọn 2' }] }} trigger={['click']}>
                                <div className="w-7 h-7 rounded-full border border-gray-300 dark:border-gray-600 flex items-center justify-center cursor-pointer hover:border-[#3e91ab] hover:text-[#3e91ab] transition-colors ml-1 shrink-0">
                                    <ChevronDown size={14} />
                                </div>
                            </Dropdown>
                        </div>
                    </div>

                    {/* Nội dung chính */}
                    <div className="mx-auto mt-4 grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-4">

                        {/* ================= CỘT TRÁI (THÔNG TIN CHỈ ĐỌC) ================= */}
                        <div className=" overflow-hidden min-w-0">
                            <div className="flex flex-col gap-6 pt-0">

                                {/* 1. THÔNG TIN CHUNG */}
                                <div className="border border-gray-100 dark:border-gray-700 rounded-lg p-4 relative bg-white dark:bg-gray-800 rounded-lg shadow-sm border dark:border-gray-700">
                                    <h3 className="font-semibold text-gray-800 dark:text-gray-100 mb-4 bg-white dark:bg-gray-800">Thông tin chung</h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-8 text-[13px] mt-4">

                                        {/* Cột 1 */}
                                        <div className="flex flex-col gap-5">
                                            <div><p className="text-gray-400 mb-1">Mã đơn hàng mua</p><p className="font-medium text-gray-800 dark:text-gray-200">ĐHM_2026_0299</p></div>
                                            <div><p className="text-gray-400 mb-1">Tên/Mã NCC</p><p className="text-gray-800 dark:text-gray-200">--</p></div>
                                            <div>
                                                <p className="text-gray-400 mb-1">Người phụ trách</p>
                                                <div className="flex items-center gap-1.5"><Avatar size={20} className="bg-gray-500 text-[10px]">H</Avatar><span className="font-medium text-000000e0">Huấn S</span></div>
                                            </div>
                                            <div><p className="text-gray-400 mb-1">Email</p><p className="text-gray-800 dark:text-gray-200">--</p></div>
                                            <div><p className="text-gray-400 mb-1">Ngày mua</p><p className="font-medium text-gray-800 dark:text-gray-200">24/02/2026</p></div>
                                            <div>
                                                <p className="text-gray-400 mb-1">Trạng thái</p>
                                                {isApproved ? (
                                                    <span className="inline-block px-2 py-0.5 bg-green-100 text-green-600 rounded text-xs font-medium">Đã duyệt</span>
                                                ) : (
                                                    <span className="inline-block px-2 py-0.5 bg-yellow-100 text-yellow-600 rounded text-xs font-medium">Chờ duyệt</span>
                                                )}
                                            </div>
                                            <div>
                                                <p className="text-gray-400 mb-1">Bước duyệt</p>
                                                <span className="inline-block px-2 py-0.5 bg-yellow-100 text-yellow-600 border border-yellow-200 rounded text-xs font-medium">Admin hệ thống kiểm tra <ChevronRight size={10} className="inline" /></span>
                                            </div>
                                            <div><p className="text-gray-400 mb-1">Tự động tạo phiếu nhập kho</p><p className="text-gray-800 dark:text-gray-200">Không</p></div>
                                            <div><p className="text-gray-400 mb-1">Tiền còn lại</p><p className="text-gray-800 dark:text-gray-200">--</p></div>
                                        </div>

                                        {/* Cột 2 */}
                                        <div className="flex flex-col gap-5">
                                            <div><p className="text-gray-400 mb-1">Nhà cung cấp</p><p className="font-medium text-gray-800 dark:text-gray-200">--</p></div>
                                            <div>
                                                <p className="text-gray-400 mb-1">Người theo dõi</p>
                                                <div className="flex items-center gap-1.5"><Avatar size={20} className="bg-green-500 text-[10px]">N</Avatar><span className="font-medium text-000000e0">Nguyệt 2</span></div>
                                            </div>
                                            <div><p className="text-gray-400 mb-1">Điện thoại</p><p className="text-gray-800 dark:text-gray-200">--</p></div>
                                            <div><p className="text-gray-400 mb-1">Địa chỉ</p><p className="text-gray-800 dark:text-gray-200">--</p></div>
                                            <div><p className="text-gray-400 mb-1">Giá trị</p><p className="font-medium text-gray-800 dark:text-gray-200">200.000 ₫</p></div>
                                            <div>
                                                <p className="text-gray-400 mb-1">Người duyệt</p>
                                                <div className="flex items-center gap-1.5"><Avatar size={20} className="bg-red-500 text-[10px]">A</Avatar><span className="font-medium text-red-500">Admin Hệ Thống</span></div>
                                            </div>
                                            <div><p className="text-gray-400 mb-1">Tình trạng xuất</p><p className="text-gray-800 dark:text-gray-200">--</p></div>
                                            <div><p className="text-gray-400 mb-1">Tạo đơn hàng từ</p><p className="text-gray-800 dark:text-gray-200">Khác</p></div>
                                            <div><p className="text-gray-400 mb-1">Ghi chú</p><p className="text-gray-800 dark:text-gray-200">--</p></div>
                                        </div>
                                    </div>
                                </div>

                                {/* 2. NỘI DUNG ĐƠN HÀNG (SẢN PHẨM) */}
                                <div className="border border-gray-100 dark:border-gray-700 rounded-lg p-4 relative p-4 relative bg-white dark:bg-gray-800 rounded-lg shadow-sm">
                                    <h3 className="font-semibold text-gray-800 dark:text-gray-100 mb-4 bg-white dark:bg-gray-800">Nội dung đơn hàng</h3>
                                    <div className="overflow-x-auto mt-4">
                                        <Table
                                            columns={productColumns}
                                            dataSource={productData}
                                            rowSelection={{ type: 'checkbox' }}
                                            pagination={false}
                                            size="small"
                                            className="font-sans min-w-[700px]"
                                            summary={() => (
                                                <>
                                                    {/* Thêm font-sans để ép dùng 1 font, đổi colSpan={5} thành colSpan={6} để đẩy sát phải */}
                                                    <Table.Summary.Row className="text-[13px] font-sans">
                                                        <Table.Summary.Cell index={0} colSpan={6} align="right" className="text-gray-500 pr-4 whitespace-nowrap">Tổng tiền</Table.Summary.Cell>
                                                        <Table.Summary.Cell index={1} align="right" className="font-medium whitespace-nowrap">200.000 ₫</Table.Summary.Cell>
                                                    </Table.Summary.Row>

                                                    <Table.Summary.Row className="text-[13px] font-semibold font-sans">
                                                        <Table.Summary.Cell index={0} colSpan={6} align="right" className="pr-4 whitespace-nowrap">Tổng tiền sau thuế</Table.Summary.Cell>
                                                        <Table.Summary.Cell index={1} align="right" className="whitespace-nowrap">200.000 ₫</Table.Summary.Cell>
                                                    </Table.Summary.Row>
                                                </>
                                            )}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* ================= CỘT PHẢI (THẢO LUẬN / EMPTY STATE) ================= */}
                        <div className="flex flex-col gap-4 h-full min-w-0">
                            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border dark:border-gray-700 flex flex-col flex-1 min-h-[600px]">
                                <Tabs
                                    defaultActiveKey="1"
                                    className="px-4 pt-2 flex-1 flex flex-col"
                                    items={[
                                        {
                                            key: '1',
                                            label: 'Thảo luận',
                                            children: (
                                                <div className="flex flex-col h-full mt-2 relative">

                                                    {/* Khu vực hiển thị bình luận */}
                                                    <div className="flex-1 overflow-y-auto mb-4 pr-2">
                                                        {comments.length === 0 ? (
                                                            // EMPTY STATE NẾU KHÔNG CÓ BÌNH LUẬN
                                                            <div className="flex flex-col items-center justify-center h-[300px] text-gray-400 opacity-60">
                                                                <MessageSquareDashed size={48} className="mb-3" strokeWidth={1} />
                                                                <p className="text-sm">Không có thảo luận nào</p>
                                                            </div>
                                                        ) : (
                                                            // NẾU CÓ BÌNH LUẬN
                                                            comments.map(comment => (
                                                                <div key={comment.id} className="flex gap-3 mb-6">
                                                                    <Avatar style={{ backgroundColor: '#84cc16' }}>{comment.author.charAt(0)}</Avatar>
                                                                    <div className="flex-1">
                                                                        <span className="font-semibold text-gray-800 dark:text-gray-200 text-sm">{comment.author}</span>
                                                                        <div className="bg-gray-100 dark:bg-gray-700/50 p-3 rounded-lg rounded-tl-none mt-1 text-sm text-000000e0 w-fit">
                                                                            {comment.text}
                                                                        </div>
                                                                        <div className="flex items-center gap-4 mt-2 text-[11px] text-gray-500">
                                                                            <span>{comment.time}</span>
                                                                            <span className="cursor-pointer hover:text-[#3e91ab]">Thích</span>
                                                                            <span className="cursor-pointer hover:text-[#3e91ab]">Trả lời</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        )}
                                                    </div>

                                                    {/* Ô Input nhập liệu */}
                                                    <div className="border border-gray-200 dark:border-gray-600 rounded-md p-2 bg-gray-50 dark:bg-gray-700/30 shrink-0 mt-auto">
                                                        <div className="flex items-center gap-2 mb-2">
                                                            <Avatar size={24} className="bg-gray-300"><User size={14} /></Avatar>
                                                            <Input
                                                                bordered={false}
                                                                placeholder="Viết thảo luận..."
                                                                className="flex-1 text-sm"
                                                                value={inputValue}
                                                                onChange={(e) => setInputValue(e.target.value)}
                                                                onPressEnter={handleSendComment}
                                                            />
                                                        </div>
                                                        <div className="flex justify-between items-center text-gray-400 pl-8 pr-2">
                                                            <div className="flex gap-3">
                                                                <Paperclip size={16} className="cursor-pointer hover:text-[#3e91ab]" />
                                                                <Smile size={16} className="cursor-pointer hover:text-[#3e91ab]" />
                                                            </div>
                                                            <Send size={16} className="cursor-pointer text-[#3e91ab]" onClick={handleSendComment} />
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        },
                                        {
                                            key: '2',
                                            label: 'Lịch sử hoạt động',
                                            children: (
                                                <div className="mt-4">
                                                    {/* Item 1 */}
                                                    <div className="relative pl-6 border-l border-gray-200 dark:border-gray-600 ml-4 pb-6">
                                                        <div className="absolute -left-[16px] top-0 bg-white dark:bg-gray-800 rounded-full p-0.5">
                                                            <Avatar style={{ backgroundColor: '#84cc16' }} size={28} className="text-xs">H</Avatar>
                                                        </div>
                                                        <div className="pt-0.5">
                                                            <div className="text-sm dark:text-gray-300">
                                                                <span className="font-semibold text-gray-800 dark:text-gray-200">Mr. Huấn</span> đã duyệt
                                                            </div>
                                                            <div className="text-xs text-gray-400 mb-2 mt-0.5">11:42 ngày 22/08/2026</div>
                                                            <div className="bg-[#f8fafc] dark:bg-gray-700/30 p-3 rounded-md text-sm text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700">
                                                                Bước: Admin hệ thống duyệt
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Item 2 */}
                                                    <div className="relative pl-6 border-l border-gray-200 dark:border-gray-600 ml-4 pb-6 border-transparent">
                                                        <div className="absolute -left-[16px] top-0 bg-white dark:bg-gray-800 rounded-full p-0.5">
                                                            <Avatar style={{ backgroundColor: '#84cc16' }} size={28} className="text-xs">H</Avatar>
                                                        </div>
                                                        <div className="pt-0.5">
                                                            <div className="text-sm dark:text-gray-300">
                                                                <span className="font-semibold text-gray-800 dark:text-gray-200">Mr. Huấn</span> đã tạo đơn hàng
                                                            </div>
                                                            <div className="text-xs text-gray-400 mb-2 mt-0.5">10:49 ngày 22/08/2026</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    ]}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ================= MODAL: DUYỆT ĐƠN HÀNG (Hình 2) ================= */}
                    <Modal
                        title={<span className="text-000000e0 font-medium">Duyệt Đơn hàng mua</span>}
                        open={isApproveModalOpen}
                        onCancel={() => setIsApproveModalOpen(false)}
                        footer={[
                            <Button
                                key="submit"
                                type="primary"
                                style={{ backgroundColor: '#3e91ab', borderColor: '#3e91ab' }}
                                onClick={() => {
                                    // Đổi trạng thái thành Đã duyệt và đóng modal
                                    setIsApproved(true);
                                    setIsApproveModalOpen(false);
                                }}
                            >
                                DUYỆT
                            </Button>,
                            <Button key="back" onClick={() => setIsApproveModalOpen(false)}>
                                KHÔNG DUYỆT
                            </Button>,
                        ]}
                    >
                        <div className="py-2 text-gray-600 dark:text-gray-300">
                            <p className="mb-2 text-[13px] font-medium text-gray-700">Duyệt 1 đơn hàng mua đã chọn</p>
                            <TextArea
                                placeholder="Thêm ý kiến hoặc để trống"
                                autoSize={{ minRows: 3, maxRows: 5 }}
                                className="w-full focus:border-[#3e91ab] focus:ring-[#3e91ab]"
                            />
                        </div>
                    </Modal>

                </div>
            </ConfigProvider>
        </Layout>
    );
}